/** Cloud Functions write `completed`; legacy docs may use `COMPLETED`. */
export const RESOURCE_PURCHASE_COMPLETED_STATUSES = [
  "completed",
  "COMPLETED",
] as const;

export function isResourcePurchaseCompleted(
  status: string | undefined | null,
): boolean {
  if (status == null) return false;
  return String(status).toLowerCase() === "completed";
}
